import { type PropsWithChildren, useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { retrieveValue } from "../../utility/storage";

interface AnimateFromProps {
    duration?: number;
    delay?: number;
    style: unknown;
    inline?: boolean;
}

const AnimateFrom = (props: PropsWithChildren<AnimateFromProps>) => {
    const ref = useRef(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (ref.current) {
            if (retrieveValue("animations", "1") != "0") {
                gsap.from(ref.current, {
                    duration: props.duration == null ? 0.5 : props.duration,
                    delay: props.delay == null ? 0.5 : props.delay,
                    ...props.style as React.CSSProperties
                });

            }
            if (ready == false) {
                setReady(true);
            }

        }
    }, [ref]);

    return <div style={{ display: props.inline == true ? "inline" : "block" }} ref={ref}>{ready == true && (props.children)}</div>
}

export default AnimateFrom;